export default __webpack_public_path__ + "static/media/480_dummy2016-baeckerei01-de.95adbc61.png";